import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { Form } from "react-bootstrap";

import { showError, showSuccess } from "redux/actions/ui";
import { updateFacilityTeeSheetSettings } from "redux/actions/facility";

import { useAppDispatch, useAppSelector } from "hooks/redux";

import Toggle from "components/form/toggle/Toggle";
import Page from "components/page/Page";
import Card from "components/card/Card";
import Input from "components/form/input/Input";
import FormLayout from "components/form/FormLayout";
import DatePickerInput from "components/datePickerInput/DatePickerInput";
import TextEditor from "components/textEditor/textEditor";
import { Select } from "components/select/index";
import { ButtonNew as Button } from "components/buttonNew";

import "./teeSheetGeneral.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleChangeEventInput, isEmpty } from "helpers/Helpers";
import { isEqualWith } from "lodash";
import ReactDOM from "react-dom";
import TimePick from "components/timePick/TimePick";
import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";

const dropdownOptions = (t: any) => [
  { label: t("Allow"), value: "allow" },
  { label: "None", value: "none" }, // TODO: Translation
  { label: "Allow within group", value: "allow_within_group" }, // TODO:Translation
];

const rainCheckExpirationOptions = [
  { label: "One Year", option: "one_year" },
  { label: "End of Year", option: "end_of_year" }, // TODO: Translation
  { label: t("No Expiration"), option: "no_expiry" },
];

export default function TeeSheetGeneral() {
  const { Option } = Select;

  const dispatch = useAppDispatch();
  const facilityStore = useAppSelector(state => state.facilityStore);

  const [stateBeforeChanges, setStateBeforeChanges] = useState<IPutTeeSheetSettings>(undefined);
  // const [cardReaderLoaded, setCardReaderLoaded] = useState<Boolean>(false);

  const [state, setState] = useState<IPutTeeSheetSettings>({
    web_cancellation_hours: null,
    web_edit_hours: null,
    enable_web_booking: false,
    max_booking_size: 16,
    display_customer_type: false,
    booking_terms: "",
    payment_terms: "",
    marketing_section: "",
    single_bookings: "",
    twosome_bookings: "",
    threesome_bookings: "",
    foursome_bookings: "",
    enable_cart_bookings: null,
    display_online_pricing: false,
    power_cart_maintenance_time: 0,
    power_cart_nine_hole_time: 0,
    power_cart_eighteen_hole_time: 0,
    default_carts_available: null,
    track_cart_numbers: false,
    use_cart_inventory: false,
    display_turn_division_code: false,
    display_booking_graph: false,
    default_open_structure: "",
    default_days_in_advance_start: 0,
    default_days_in_advance_end: 0,
    default_open_time: "",
    cart_waiver_content: "",
    web_tee_times_display: null,
    validate_power_cart_count: false,
    gift_cards_default_auto_generate_code: false,
    rain_check_expiry: "one_year",
    booking_buffer: null,
    highlight_new_bookings: false,
    highlight_new_bookings_window: 0,
  });

  /*function initializeOverrideTeeSheetDateRange(): [Date, Date] {
    const firstDayOfThisWeek = new Date();
    firstDayOfThisWeek.setDate(firstDayOfThisWeek.getDate() - firstDayOfThisWeek.getDay());

    const lastDayOfThisWeek = new Date(firstDayOfThisWeek);
    lastDayOfThisWeek.setDate(lastDayOfThisWeek.getDate() + 6);

    return [firstDayOfThisWeek, lastDayOfThisWeek];
  }

  const [overrideTeeSheetDateRange, setOverrideTeeSheetDateRange] = useState<[Date, Date]>(
    initializeOverrideTeeSheetDateRange,
  );
  const [overrideTeeSheets, setOverrideTeeSheets] = useState<IOverrideTeeSheet[]>([]);
  const [overrideTeeSheetsBeforeChanges, setOverrideTeeSheetsBeforeChanges] = useState<IOverrideTeeSheet[]>([]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    void loadTeeSheets(source.token);

    return () => source.cancel();
  }, [overrideTeeSheetDateRange]);

  async function loadTeeSheets(token?: CancelToken) {
    const getTeeSheetsRes = await GetTeeSheets(
      {
        date_range: [formatDate(overrideTeeSheetDateRange[0]), formatDate(overrideTeeSheetDateRange[1])],
      },
      false,
      token,
    );

    if (token?.reason) {
      return;
    }

    if (getTeeSheetsRes.status !== StatusCode.OK) {
      setOverrideTeeSheets([]);
      setOverrideTeeSheetsBeforeChanges([]);
      return;
    }

    const updatedOverrideTeeSheets = getTeeSheetsRes.data.map(teeSheet => {
      const splitDate = teeSheet.date?.split("-");
      const date = splitDate
        ? new Date(parseInt(splitDate[0]), parseInt(splitDate[1]) - 1, parseInt(splitDate[2]))
        : undefined;

      return {
        id: teeSheet.id,
        date: date?.toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric" }) ?? "",
        cartsAvailable: teeSheet.carts_available == null ? "" : String(teeSheet.carts_available),
      };
    });

    setOverrideTeeSheets(updatedOverrideTeeSheets);
    setOverrideTeeSheetsBeforeChanges(updatedOverrideTeeSheets);
  }

  function updateOverrideTeeSheetCartsAvailable(id: number, cartsAvailable: string) {
    setOverrideTeeSheets(prev =>
      prev.map(overrideTeeSheet => {
        if (id === overrideTeeSheet.id) {
          return {
            ...overrideTeeSheet,
            cartsAvailable,
          };
        } else {
          return overrideTeeSheet;
        }
      }),
    );
  }*/

  const [dates, setDates] = useState<{ open_date: Date; close_date: Date } | undefined>({
    open_date: new Date(),
    close_date: new Date(),
  });

  const [dateBeforeChanges, setDateBeforeChanges] = useState<{ open_date: Date; close_date: Date }>(undefined);

  const [link, setLink] = useState({
    clientShortName: "",
    facilityShortName: "",
  });

  useEffect(() => {
    if (facilityStore.facility) {
      setLink(prevState => ({
        ...prevState,
        facilityShortName: facilityStore.facility?.short_name,
        clientShortName: facilityStore.facility?.client?.short_name,
      }));
    }
  }, [facilityStore.facility]);

  //stop unnecessary re-assignment when facilityStore changes
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const settings = facilityStore.teeSheetSettings;

    if (settings && !isLoaded) {
      setState({
        web_cancellation_hours: settings.web_cancellation_hours,
        web_edit_hours: settings.web_edit_hours,
        enable_web_booking: !!settings.enable_web_booking,
        max_booking_size: settings.max_booking_size,
        display_customer_type: !!settings.display_customer_type,
        booking_terms: settings.booking_terms,
        payment_terms: settings.payment_terms,
        marketing_section: settings.marketing_section,
        single_bookings: settings.single_bookings,
        twosome_bookings: settings.twosome_bookings,
        threesome_bookings: settings.threesome_bookings,
        foursome_bookings: settings.foursome_bookings,
        enable_cart_bookings: !!settings.enable_cart_bookings,
        display_online_pricing: !!settings.display_online_pricing,
        power_cart_maintenance_time: settings.power_cart_maintenance_time,
        power_cart_nine_hole_time: settings.power_cart_nine_hole_time,
        power_cart_eighteen_hole_time: settings.power_cart_eighteen_hole_time,
        default_carts_available: settings.default_carts_available,
        track_cart_numbers: !!settings.track_cart_numbers,
        use_cart_inventory: !!settings.use_cart_inventory,
        display_turn_division_code: !!settings.display_turn_division_code,
        display_booking_graph: !!settings.display_booking_graph,
        default_open_structure: settings.default_open_structure,
        default_days_in_advance_start: settings.default_days_in_advance_start,
        default_days_in_advance_end: settings.default_days_in_advance_end,
        default_open_time: settings.default_open_time,
        cart_waiver_content: settings.cart_waiver_content,
        web_tee_times_display: settings.web_tee_times_display,
        validate_power_cart_count: !!settings.validate_power_cart_count,
        gift_cards_default_auto_generate_code: settings.gift_cards_default_auto_generate_code,
        rain_check_expiry: settings.rain_check_expiry,
        booking_buffer: settings.booking_buffer,
        highlight_new_bookings: settings.highlight_new_bookings,
        highlight_new_bookings_window: settings.highlight_new_bookings_window ?? 0,
      });

      if (settings.open_date && settings.close_date) {
        const splitOpenDate: string[] = settings.open_date.split("-");
        const splitCloseDate: string[] = settings.close_date.split("-");
        setDates({
          open_date: new Date(parseInt(splitOpenDate[0]), parseInt(splitOpenDate[1]) - 1, parseInt(splitOpenDate[2])),
          close_date: new Date(
            parseInt(splitCloseDate[0]),
            parseInt(splitCloseDate[1]) - 1,
            parseInt(splitCloseDate[2]),
          ),
        });
      }

      setIsLoaded(true);
    }
  }, [facilityStore.teeSheetSettings]);

  function saveTeeSheetSettings() {
    if (dates.close_date < dates.open_date) {
      dispatch(showError(t("secure.facility.settings.tee_sheets.tee_sheet_general.010")));
    }

    // arbitrary booking size limits
    if (state.max_booking_size > 64) {
      dispatch(showError(t("secure.facility.settings.tee_sheets.tee_sheet_general.011")));
      return;
    } else if (state.max_booking_size < 5) {
      dispatch(showError(t("secure.facility.settings.tee_sheets.tee_sheet_general.012")));
      return;
    }

    const putParams: IPutTeeSheetSettings = {
      web_cancellation_hours: state.web_cancellation_hours,
      web_edit_hours: state.web_edit_hours,
      enable_web_booking: state.enable_web_booking,
      enable_cart_bookings: state.enable_cart_bookings,
      max_booking_size: state.max_booking_size,
      open_date: dates.open_date.toISOString().slice(0, 10),
      close_date: dates.close_date.toISOString().slice(0, 10),
      display_customer_type: state.display_customer_type,
      booking_terms: state.booking_terms,
      payment_terms: state.payment_terms,
      marketing_section: state.marketing_section,
      single_bookings: state.single_bookings,
      twosome_bookings: state.twosome_bookings,
      threesome_bookings: state.threesome_bookings,
      foursome_bookings: state.foursome_bookings,
      display_online_pricing: state.display_online_pricing,
      power_cart_maintenance_time: state.power_cart_maintenance_time,
      power_cart_nine_hole_time: state.power_cart_nine_hole_time,
      power_cart_eighteen_hole_time: state.power_cart_eighteen_hole_time,
      default_carts_available: state.default_carts_available,
      track_cart_numbers: state.track_cart_numbers,
      use_cart_inventory: state.use_cart_inventory,
      display_turn_division_code: state.display_turn_division_code,
      display_booking_graph: state.display_booking_graph,
      default_open_structure: state.default_open_structure,
      default_days_in_advance_start: state.default_days_in_advance_start,
      default_days_in_advance_end: state.default_days_in_advance_end,
      default_open_time: state.default_open_time,
      cart_waiver_content: state.cart_waiver_content,
      web_tee_times_display: state.web_tee_times_display,
      validate_power_cart_count: state.validate_power_cart_count,
      gift_cards_default_auto_generate_code: state.gift_cards_default_auto_generate_code,
      rain_check_expiry: state.rain_check_expiry,
      booking_buffer: state.booking_buffer,
      highlight_new_bookings: state.highlight_new_bookings,
      highlight_new_bookings_window: state.highlight_new_bookings_window,
    };

    ReactDOM.unstable_batchedUpdates(() => {
      setStateBeforeChanges(state);
      setDateBeforeChanges(dates);
      // setOverrideTeeSheetsBeforeChanges(overrideTeeSheets);
      void dispatch(updateFacilityTeeSheetSettings(putParams, true));
    });
  }

  function handleInputChange(event: any) {
    const { id, value } = event.target;
    setState(prevState => ({ ...prevState, [id]: value === "" || value < 0 ? "" : Number(value) }));
  }

  function handleToggleTrackCartNumbers(event: React.ChangeEvent<HTMLInputElement>) {
    const { checked } = event.target;
    setState(prevState => ({ ...prevState, track_cart_numbers: checked, use_cart_inventory: false }));
  }

  function handleToggleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { id, checked } = event.target;
    setState(prevState => ({ ...prevState, [id]: checked }));
  }

  function handleBookingTermsChange(terms: string) {
    setState(prevState => ({ ...prevState, booking_terms: terms }));
  }

  function handlePaymentTermsChange(terms: string) {
    setState(prevState => ({ ...prevState, payment_terms: terms }));
  }

  function handleDropDownChange(value: string, key: string) {
    setState(prevState => ({ ...prevState, [key]: value }));
  }

  async function writeTextToClipBoard(link: string) {
    await navigator.clipboard.writeText(link);
    dispatch(showSuccess(t("secure.facility.tournament.tournament.003")));
  }

  function unsavedChangesExist() {
    if (stateBeforeChanges === undefined) {
      if (isLoaded) {
        setStateBeforeChanges(state);
        setDateBeforeChanges(dates);
      }
      return false;
    }

    return (
      !isEqualWith(stateBeforeChanges, state) || !isEqualWith(dateBeforeChanges, dates)
      // !isEqualWith(overrideTeeSheetsBeforeChanges, overrideTeeSheets)
    );
  }

  function cancelUnsavedChanges() {
    setState(stateBeforeChanges);
    setDates(dateBeforeChanges);
    // setOverrideTeeSheets(overrideTeeSheetsBeforeChanges);
  }

  function handleChangeDefaultCartsAvailable(e: React.ChangeEvent<HTMLInputElement>) {
    const updatedDefaultCartsAvailable = isEmpty(e.target.value) ? null : Number(e.target.value);

    if (
      isNaN(updatedDefaultCartsAvailable) ||
      updatedDefaultCartsAvailable < 0 ||
      updatedDefaultCartsAvailable % 1 !== 0
    ) {
      e.preventDefault();
    } else {
      setState(prev => ({
        ...prev,
        default_carts_available: updatedDefaultCartsAvailable,
      }));
    }
  }

  /*function isCartsAvailableOverrideValid(cartsAvailable: string) {
    return isEmpty(cartsAvailable) || isWholeNumber(cartsAvailable);
  }*/

  console.log(state);

  return (
    <Page
      title={t("secure.facility.settings.tee_sheets.tee_sheet_general.002")}
      narrow
      notificationBarProps={{
        isVisible: unsavedChangesExist(),
        onAction: saveTeeSheetSettings,
        onCancel: cancelUnsavedChanges,
      }}
    >
      <Card>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Toggle
                  labelRight={t("secure.facility.settings.tee_sheets.tee_sheet_general.003")}
                  id="enable_web_booking"
                  checked={!!state.enable_web_booking || false}
                  onChange={handleToggleChange}
                />
                <Toggle
                  labelRight={t("secure.facility.settings.tee_sheets.tee_sheet_general.016")}
                  id="display_customer_type"
                  checked={!!state.display_customer_type || false}
                  onChange={handleToggleChange}
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Toggle
                  labelRight={"Display Online Pricing"}
                  id="display_online_pricing"
                  checked={!!state.display_online_pricing || false}
                  onChange={handleToggleChange}
                />
                <Toggle
                  labelRight={"Display Booking Graph"}
                  id="display_booking_graph"
                  checked={!!state.display_booking_graph || false}
                  onChange={handleToggleChange}
                />
              </FormLayout.Group>

              <FormLayout.Group>
                <Toggle
                  labelRight={t("Display Turn Division Code")} // TODO: Translation
                  id="display_turn_division_code"
                  checked={!!state.display_turn_division_code || false}
                  onChange={handleToggleChange}
                />
              </FormLayout.Group>

              <FormLayout.Group>
                <Input
                  value={state.web_cancellation_hours || ""}
                  label={t("secure.facility.settings.tee_sheets.tee_sheet_general.004")}
                  id="web_cancellation_hours"
                  helpText={t("secure.facility.settings.tee_sheets.tee_sheet_general.005")}
                  onChange={handleInputChange}
                  suffix="hours"
                  placeholder={t("secure.facility.settings.tee_sheets.tee_sheet_general.006")}
                />
                <Input
                  value={state.web_edit_hours || ""}
                  label={t("secure.facility.settings.tee_sheets.tee_sheet_general.007")}
                  id="web_edit_hours"
                  helpText={t("secure.facility.settings.tee_sheets.tee_sheet_general.008")}
                  onChange={handleInputChange}
                  suffix="hours"
                  placeholder={t("secure.facility.settings.tee_sheets.tee_sheet_general.009")}
                />
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>

        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <Toggle
                labelRight={"Highlight New Bookings"}
                id="highlight_new_bookings"
                checked={!!state.highlight_new_bookings || false}
                onChange={handleToggleChange}
              />
            </FormLayout.Group>

            {state.highlight_new_bookings ? (
              <FormLayout.Group>
                <Input
                  value={state.highlight_new_bookings_window || ""}
                  label={"Highlight New Bookings Window"}
                  id="highlight_new_bookings_window"
                  onChange={handleInputChange}
                  placeholder={"0"}
                  suffix={"hours"}
                />
              </FormLayout.Group>
            ) : null}
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <div className="open-close-date">
                  <div>
                    <span className="label-span">
                      {t("secure.facility.settings.tee_sheets.tee_sheet_general.013")} {/* TODO: Translation */}
                    </span>
                    <DatePickerInput
                      startingDate={dates.open_date}
                      setStartingDate={(date: Date) => setDates({ ...dates, open_date: date })}
                      months={1}
                      position="left"
                    />
                  </div>
                </div>
                <div className="open-close-date">
                  <div>
                    <span className="label-span">{t("secure.facility.settings.tee_sheets.tee_sheet_general.014")}</span>
                    <DatePickerInput
                      startingDate={dates.close_date}
                      setStartingDate={(date: Date) => setDates({ ...dates, close_date: date })}
                      months={1}
                      position="right"
                    />
                  </div>
                </div>
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("secure.facility.settings.tee_sheets.tee_sheet_general.015")} // TODO: Translation
                  type="number"
                  id="max_booking_size"
                  min={5} //necessary because of UI layout
                  value={state.max_booking_size}
                  onChange={handleInputChange}
                />
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Select
                  label={"Single Bookings"}
                  defaultValue={state.single_bookings}
                  onChange={(value: string) => handleDropDownChange(value, "single_bookings")}
                >
                  {dropdownOptions(t).map((option, index) => (
                    <Option key={index} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
                {/* <Select
                  label={"Twosome Bookings"}
                  defaultValue={state.twosome_bookings}
                  onChange={(value: string) => handleDropDownChange(value, "twosome_bookings")}
                >
                  {dropdownOptions(t).map((option, index) => (
                    <Option key={index} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select> */}
              </FormLayout.Group>
              {/* <FormLayout.Group>
                <Select
                  label={"Threesome Bookings"}
                  defaultValue={state.threesome_bookings}
                  onChange={(value: string) => handleDropDownChange(value, "threesome_bookings")}
                >
                  {dropdownOptions.map((option, index) => (
                    <Option key={index} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
                <Select
                  label={"Foursome Bookings"}
                  defaultValue={state.foursome_bookings}
                  onChange={(value: string) => handleDropDownChange(value, "foursome_bookings")}
                >
                  {dropdownOptions.map((option, index) => (
                    <Option key={index} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </FormLayout.Group> */}
              <FormLayout.Group>
                <Select
                  label={t("Web Tee Times Display")}
                  defaultValue={state.web_tee_times_display ?? ""}
                  onChange={(value: string) => handleDropDownChange(value, "web_tee_times_display")}
                  helpText={t("Select how customers will view and book tee times")}
                >
                  {[
                    { label: t("List"), value: "list" },
                    { label: t("Tee Sheet"), value: "tee_sheet" },
                  ].map((option, index) => (
                    <Option key={index} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>
        <Card.Section>
          <Select
            label={t("Rain Check Expiry")}
            defaultValue={state.rain_check_expiry ?? ""}
            onChange={(value: string) => handleDropDownChange(value, "rain_check_expiry")}
            helpText={t("Select how rain checks will expire")}
          >
            {rainCheckExpirationOptions.map((option, index) => (
              <Select.Option key={index} value={option.option}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Card.Section>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <Input
                label={t("Days In Advance Start")}
                type="number"
                id="default_days_in_advance_start"
                value={state.default_days_in_advance_start}
                onChange={handleInputChange}
                suffix={t("Days")}
              />
              <Input
                label={t("Days In Advance End")}
                type="number"
                id="default_days_in_advance_end"
                value={state.default_days_in_advance_end}
                onChange={handleInputChange}
                suffix={t("Days")}
              />
              <TimePick
                value={state.default_open_time}
                label={t("Default Open Time")}
                onChange={timeString => setState(prev => ({ ...prev, default_open_time: timeString }))}
                size="large"
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <Input
                label={t("Minimum Time Between Bookings")}
                type="number"
                id="booking_buffer"
                value={state.booking_buffer}
                onChange={handleInputChange}
                suffix={t("Minutes")}
                tooltipText={t(
                  "Minimum time in minutes between bookings for online booking. Leaving this setting empty will result in no restriction.",
                )} // TODO: Translation
                min={0}
              />
            </FormLayout.Group>
          </FormLayout>
        </Card.Section>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <TextEditor
                markdownText={state.booking_terms ?? ""}
                markdownTextOnChange={handleBookingTermsChange}
                label={t("secure.facility.settings.tee_sheets.tee_sheet_general.017")}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextEditor
                markdownText={state.payment_terms ?? ""}
                markdownTextOnChange={handlePaymentTermsChange}
                label={t("secure.facility.settings.tee_sheets.tee_sheet_general.018")}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextEditor
                markdownText={state.marketing_section ?? ""}
                markdownTextOnChange={terms => setState(prevState => ({ ...prevState, marketing_section: terms }))}
                label={t("secure.facility.settings.tee_sheets.tee_sheet_general.019")}
              />
            </FormLayout.Group>
          </FormLayout>
        </Card.Section>
        <Card.Section title="Power Cart Settings">
          <FormLayout>
            <FormLayout.Group>
              <div>
                <Toggle
                  labelRight={"Track Cart Numbers"}
                  checked={!!state.track_cart_numbers || false}
                  onChange={handleToggleTrackCartNumbers}
                />
                {state.track_cart_numbers ? (
                  <div className="ml-3">
                    <Toggle
                      labelRight={t("Use Cart Inventory")}
                      id="use_cart_inventory"
                      checked={!!state.use_cart_inventory || false}
                      onChange={handleToggleChange}
                    />
                  </div>
                ) : null}
              </div>
              <Toggle
                labelRight={t("Enable Cart Bookings")} // TODO: Translation
                id="enable_cart_bookings"
                checked={!!state.enable_cart_bookings || false}
                onChange={handleToggleChange}
              />
              <Toggle
                labelRight={t("Validate Power Cart Count")}
                id="validate_power_cart_count"
                checked={!!state.validate_power_cart_count || false}
                onChange={handleToggleChange}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <Input
                label={t("Maintenance Time")}
                type="number"
                id="power_cart_maintenance_time"
                value={state.power_cart_maintenance_time === null ? 0 : state.power_cart_maintenance_time}
                onChange={handleInputChange}
                suffix={t("Minutes")}
              />
              <Input
                label={t("9 Hole Time")} // TODO: Translation
                type="number"
                id="power_cart_nine_hole_time"
                value={state.power_cart_nine_hole_time === null ? 0 : state.power_cart_nine_hole_time}
                onChange={handleInputChange}
                suffix={t("Minutes")}
              />
              <Input
                label={t("18 Hole Time")} // TODO: Translation
                type="number"
                id="power_cart_eighteen_hole_time"
                value={state.power_cart_eighteen_hole_time === null ? 0 : state.power_cart_eighteen_hole_time}
                onChange={handleInputChange}
                suffix={t("Minutes")}
              />
            </FormLayout.Group>

            {!state.use_cart_inventory && (
              <FormLayout.Group>
                <Input
                  label={t("Carts Available")}
                  value={state.default_carts_available ?? ""}
                  onChange={handleChangeDefaultCartsAvailable}
                />
              </FormLayout.Group>
            )}
          </FormLayout>

          {/*<div className="power-carts-available-overrides-title">
            Power Carts Available Overrides
          </div>

          {overrideTeeSheetDateRange?.[0] && overrideTeeSheetDateRange?.[1] && (
            <div className="power-carts-available-overrides-date-range">
              {overrideTeeSheetDateRange[0].toLocaleDateString("en-CA", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
              <FontAwesomeIcon className="power-carts-available-overrides-date-range-dash" icon={["far", "dash"]} />
              {overrideTeeSheetDateRange[1].toLocaleDateString("en-CA", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </div>
          )}

          <DataTable
            columns={[
              { label: "Date", width: "50%" },
              { label: "Carts Available", width: "50%" },
            ]}
            footer={{
              tableLimit: 7,
              tableOffset: 7,
              handleTableOffset: (direction: "prev" | "next") => {
                setOverrideTeeSheetDateRange(prev => {
                  const [start, end] = prev;

                  const updatedStart = new Date(start);
                  const updatedEnd = new Date(end);

                  updatedStart.setDate(updatedStart.getDate() + (direction === "prev" ? -7 : 7));
                  updatedEnd.setDate(updatedEnd.getDate() + (direction === "prev" ? -7 : 7));

                  return [updatedStart, updatedEnd];
                });
              },
              disableNextOffset: false,
            }}
          >
            {overrideTeeSheets?.map(overrideTeeSheet => {
              return (
                <tr key={overrideTeeSheet.id}>
                  <td>{overrideTeeSheet.date}</td>
                  <td>
                    <Input
                      value={overrideTeeSheet.cartsAvailable}
                      onChange={e => updateOverrideTeeSheetCartsAvailable(overrideTeeSheet.id, e.target.value)}
                      error={!isCartsAvailableOverrideValid(overrideTeeSheet.cartsAvailable)}
                    />
                  </td>
                </tr>
              );
            })}
          </DataTable>*/}
        </Card.Section>

        <Card.Section title={"Links"}>
          <Input
            disabled={true}
            value={window.origin + `/portal/${link?.clientShortName}/teetimes/${link?.facilityShortName}`}
            id="portal_link"
            // onChange={e => handleChangeEventInput(e, link, setLink)}
            trailingButtons={[
              <Button
                key={1}
                onClick={() =>
                  void writeTextToClipBoard(
                    window.origin + `/portal/${link?.clientShortName}/teetimes/${link?.facilityShortName}`,
                  )
                }
              >
                {" "}
                <FontAwesomeIcon icon={["far", "copy"]} style={{ marginRight: "5px" }} /> Copy {/* TODO: Translation */}
              </Button>,
            ]}
          />
          <Input
            disabled={true}
            value={window.origin + "/tee-on/portal/login"}
            id="portal_login_link"
            onChange={e => handleChangeEventInput(e, link, setLink)}
            trailingButtons={[
              <Button key={1} onClick={() => void writeTextToClipBoard(window.origin + "/tee-on/portal/login")}>
                {" "}
                <FontAwesomeIcon icon={["far", "copy"]} style={{ marginRight: "5px" }} /> Copy {/* TODO: Translation */}
              </Button>,
            ]}
          />
        </Card.Section>
      </Card>
    </Page>
  );
}
